'use strict'

import React from 'react'

import DynG from '../utils/Global';

// import Dyn from '../lib/dynDataSet/dynMiscellany';
// import ReactTable from 'react-table';
// import 'react-table/react-table.css';
import HotTable from './handsontable/react-handsontable.jsx';
import Handsontable from 'handsontable';
import { requireJrMode } from '../utils/Util';
import AttributeCard from './elem-play/editable/AttributeCard.js';
import CaseCard from './elem-play/editable/CaseCard.js';


class CaseTableComponent extends React.Component {

    state = {
        applyFilter: false, // ignored if true and in editing mode
        editingTable: false,
        rows: [],
        columnAttributeNames: [], // attribute name associated with each column
        columnHTMLHeaders: [], // name+colorKey or colorKey-only HTML string for each column header
        isSampleMode : false, // must remain false if in editing mode
        numEditableBlankRows : 0,
        numEditableHeaderRows : 0,
    }


    componentDidUpdate(prevProps, prevState){
        let Dyn = this.props.Dyn;
        if( prevProps.isActive !== this.props.isActive
            || prevState.editingTable !== this.state.editingTable ) {
            this.setBaseTable();
        }
        // Initiate edit mode when editable property is changed
        if(prevProps.editable != this.props.editable) {
            this.initEditMode();
        }
        // Force update to fix the table height
        if(prevProps.fullTableView != this.props.fullTableView) {
            setTimeout(() => {
                this.forceUpdate();
            }, 100);
        }
        // check states that currently do not work correctly in combination
        // NOTE: state.applyFilter ignored if state.editingTable===true
        Dyn.assert( !( this.state.isSampleMode && this.state.editingTable ), "edit mode not allowed while sampling");
    }

    componentDidMount = () => {
        let Dyn = this.props.Dyn;
        this.subscriptions = [];
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:randomSamplesUpdated", (data) => {
            let newState = { isSampleMode: Boolean(data.sampleSets.length > 0) };
            if( newState.isSampleMode ) {
                newState.editingTable = false;
            }
            this.setState( newState );
        });
        // Listen for edit mode change from Jr. edit view
        Dyn.mediatorLocalSubscribe( this.subscriptions, "elemPlayContainer:editModeOn", (data) => {
            this.handleEditModeChange(true, true);
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "elemPlayContainer:editModeOff", (data) => {
            this.handleEditModeChange(false, true);
        });
    }
    componentWillUnmount = () => {
        this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
    }

    initEditMode = () => {
        // start in Edit mode only if empty editable table (not counting default "Cases" attribute)
        let Dyn = this.props.Dyn;
        //Dyn.assert( Dyn.dataSet && (Dyn.dataSet.getNumAttributes() > 0) && Dyn.dataSet.attribs[0].isCaseAttribute );
        let isEditing = this.props.editable;
        if(this.props.onTableDataSave) {
            // Set editing mode false by default when ontableDataSave is defined (when save button is internal)
            isEditing = Dyn.dataSet.getNumAttributes() <= 1;
        }
        this.setState({
            editingTable: isEditing
        }, () => {
            if(isEditing) {
                // Call prepareEditMode after timeout to make sure tableview is switched to edit mode
                setTimeout(this.prepareEditMode, 100);
            }
        });
    }

    prepareEditMode = () => {
        let Dyn = this.props.Dyn;
        // Select the first cell when there are no attributes
        if(Dyn.dataSet.getNumAttributes() <= 1) {
            this.hotTable?.hotInstance.selectCell( 0, 1 );
        }
    }

    getDirtyRawData = () => {
        // return raw data when the table is in edit mode
        return this.state.editingTable? this.getRawData(): [];
    }

    setBaseTable = () => {
        let Dyn = this.props.Dyn;
        //console.log("CaseTableComponent:setBaseTable()", Dyn.dataSet.getNumAttributes(), 'attributes', Dyn.dataSet.getNumCasesPreFilter(), 'cases');

        function getColumnFlags( attribute, isEditingTable ) {
            // Marking derived attribute columns as readOnly using column index
            let c = {
                readOnly: !attribute.isEditable() || !isEditingTable
            };
            // Mark columns that can be sorted and displayed as simple numbers
            if( attribute.isFormatType('rawNumbers') ) {
                c.type = 'numeric'; // https://handsontable.com/docs/numeric-cell-type/#overview
                c.numericFormat = { pattern: '0,0' } // https://numbrojs.com/old-format.html
                if( attribute.hasTrailingZeros() ) {
                    c.numericFormat.pattern = '0,0.'+('0'.repeat(attribute.getNumericDecimals()));
                }
            }
            // Add case icon for case column
            if(attribute.id === 'id') {
                c.renderer = function(instance, td, row){
                    Handsontable.renderers.TextRenderer.apply(this, arguments);
                    if(td.innerText.toLowerCase() !== 'case') {
                        // Align text right
                        td.classList.add('tde-text-right');
                        // Add case icon addition to case number
                        const node = document.createElement("div");
                        node.classList.add('tde-case-icon');
                        td.appendChild(node);
                    }
                    return td;
                }
            }
            return c;
        }
        function getSvgColorKey( attribute, index ) {
            if( index===0 ) {
                return ''; // no color key for "Case" column
            }
            //Dyn.debugCountColorRenderings = (Dyn.debugCountColorRenderings||0)+1;
            //console.log( "getSvgColorKey count", Dyn.debugCountColorRenderings );
            let bounds = new Dyn.mathUtil.Rect( 1, 1, 48, 13 ), // fixed color key size
                svgStr = Dyn.colorUtil.makeGradientHTML( bounds, attribute, true, true );
            return svgStr;
        }

        this.setState( (state) => {
            // set rows, columnAttributeNames, columns based on state.editingTable
            let editingTable = state.editingTable,
                rows = [],
                numEditableBlankRows = 0,
                numEditableHeaderRows = 0;
            function showAttribute(attr) { return attr.isVisible || editingTable; }

            // state.rows are pre-filter, this.rows are pre- or post-filter
            // NOTE: caseValueFormat is used to pre-format the data for Handsontable
            // then getColumnFlags() is used for Handsontable to further adjust formatting
            const caseValueFormat = { rawNumbers:true, formatted:!editingTable }; // coordinate with getColumnFlags()
            for(let i=0, numCases=Dyn.dataSet.getNumCasesPreFilter(); i<numCases; i++) {
                rows.push(Dyn.dataSet.getTableRowData(i, caseValueFormat));
            }
            rows = rows.map(row => row.filter((r,index) => showAttribute( Dyn.dataSet.attribs[index])));

            // column names are of visible attribute names, or all attribute names if editing
            let visibleAttributes = Dyn.dataSet.attribs.filter(item => showAttribute(item)),
                columnAttributeNames = visibleAttributes.map((item,index) => item.name ),
                columnHTMLHeaders,
                columns = visibleAttributes.map((attr) => getColumnFlags( attr, editingTable ));

            // add extra rows and columns for editing?
            if( editingTable ) {
                const minimumNumberOfColumns = 2;
                const minimumNumberOfRows = 2;
                let numCols = Dyn.dataSet.getNumAttributes();
                // when editing, column headers have color key only
                columnHTMLHeaders = visibleAttributes.map((item,index) => getSvgColorKey(item,index));

                // Require additional column when not in jr mode or jr mode with less than 5 columns
                const requireAdditionalColumn = !requireJrMode(this.props.mode) || columns.length <= AttributeCard.MAX_ATTRIBUTES;
                if(requireAdditionalColumn) {
                    // add blank columns on right, or more if less than minimum
                    do {
                        columnAttributeNames.push( `<${Dyn.dataUtil.defaultAttributeName(numCols)}>`);
                        columnHTMLHeaders.push('');
                        columns.push({}); // readOnly false
                        rows.forEach( r => r.push( null )); // blank cells
                    } while( ++numCols <= minimumNumberOfColumns );
                }
                // put attribute names in first row
                rows.unshift( columnAttributeNames );
                ++numEditableHeaderRows;
                // add blank row with case number when number of rows are less than required number
                if(rows.length <= minimumNumberOfRows) {
                    for(let i = rows.length; i <= minimumNumberOfRows; i++) {
                        rows.push(Dyn.dataUtil.filledArray(columnAttributeNames.length, null, i ));
                        ++numEditableBlankRows;
                    }
                }
                // add blank row on bottom when not in Jr. mode or number of rows are less than required number
                const requireAdditionalRow = !requireJrMode(this.props.mode) || rows.length <= CaseCard.MAX_CASES;
                if(requireAdditionalRow) {
                    rows.push(Dyn.dataUtil.filledArray(columnAttributeNames.length, null, rows.length ));
                    ++numEditableBlankRows;
                }
            } else {
                // when not editing, column headers have attribute name (1st line) and color key (2nd line)
                columnHTMLHeaders = visibleAttributes.map((item,index) => item.name+'<br>'+getSvgColorKey(item,index));
            }
            return {
                rows: rows,
                columnAttributeNames: columnAttributeNames,
                columnHTMLHeaders: columnHTMLHeaders,
                columns: columns,
                numEditableBlankRows : numEditableBlankRows,
                numEditableHeaderRows : numEditableHeaderRows
            };
        });
    }

    // rowIndexToCaseIndex = ( ri, editingTable ) => {
    //     // use a different offset when editing -- see also firstTableRowIsAttributeName
    //     return( editingTable ? ri : ri - 1 );
    // }
    //
    // caseIndexToRowIndex = ( ci, editingTable ) => {
    //     // use a different offset when editing -- see also firstTableRowIsAttributeName
    //     return( editingTable ? ci : ci - 1 );
    // }

    /**
     * Respond to "records:setCasesSelected" message; highlight selected rows
     * @param args
     */
    setSelectedRowIds = ( args ) => {
        let Dyn = this.props.Dyn;
        // To handle bubbled events
        if (this.rowSelectionByEventTimeout) {
            clearTimeout(this.rowSelectionByEventTimeout);
            //console.log("rowSelectionByEventTimeout clearTimeout");
        }
        this.rowSelectionByEventTimeout = setTimeout(() => {
            this.rowSelectionByEventTimeout = undefined;
            if( args.isMarqueeSelectUpdate ) {
                Dyn.assert( ! args.isMarqueeSelectEnd );
                Dyn.debugging && console.log("caseTable is ignoring row selection until end of marquee select");
            } else if (this.lastSelectBy == 'user') {
                this.lastSelectBy = ""; // Ignore the event bubbled by afterSelection function call
            } else {
                this.lastSelectBy = 'event';
                //console.log("caseTable:setSelectedRowIds start");
                Dyn.time( 'caseTable:setSelectedRowIds', 'Start' );
                const rowOffset = this.state.editingTable ? 1 : 0;
                let cellsToSelect = [];

                // get groups of consecutive table rows matching the selected case(s)
                // in read only mode
                if(!this.state.editingTable && this.state.applyFilter ) {
                    // with filtering, find row with first column value == case index + 1.
                    args.ids.map( id => {
                        let rowIndex = this.rows.findIndex( r => r[0]===(id+1).toString() );
                        if( rowIndex >= 0 ) {
                            addRowToSelection( cellsToSelect, rowIndex+rowOffset );
                        }
                    });
                } else {
                    // no filtering: case ids map directly to table row index
                    args.ids.map(id => {
                        addRowToSelection( cellsToSelect, id+rowOffset );
                    });
                }
                // select rows, and handle performance issues
                // NOTE: handsontable.selectCells() time to select is slow, linear increase in selection time per group of rows
                //      See also https://handsontable.com/docs/8.3.2/tutorial-performance-tips.html
                const maxSelectionRangesWithScrollToCell = 10; // otherwise too slow
                const maxSelectionRanges = 40; // otherwise too slow
                let wantScrollToCell = (cellsToSelect.length <= maxSelectionRangesWithScrollToCell ),
                    isUnderMaxSelection = ( cellsToSelect.length <= maxSelectionRanges );
                if( this.props.isOpen && this.props.isActive && isUnderMaxSelection ) {
                    // TODO: consider using .deselectCell() instead of .selectCells cellsToSelect is empty, here an elsewhere --CDM 2021-06-28
                    this.hotTable?.hotInstance.selectCells( cellsToSelect, wantScrollToCell );
                    this.rowSelectionDeferred = null;
                } else {
                    // wait until table is opened or re-rendered (later)
                    Dyn.debugging && console.log("caseTable selection deferred, "+
                        (isUnderMaxSelection ? "because selection is to large (slow)" : "because table is not visible"));
                    this.rowSelectionDeferred = [ cellsToSelect, wantScrollToCell ];
                }
                Dyn.time( 'caseTable:setSelectedRowIds', 'End' );
                // console.log("caseTable:setSelectedRowIds() end",
                //     "selecting "+args.ids.length+" cases in "+cellsToSelect.length+" groups.",
                //     "scrollToCell:"+wantScrollToCell);
            }
        }, 300);

        // for each case selected, select all columns and the matching row
        const columnStart = this.state.columnAttributeNames.length - 1,
              columnEnd = 0; // end on 0th column avoid horizontal scroll to right #1319
        function addRowToSelection( cellsToSelect, rowIndex ) {
            let lastSelectedRow = (cellsToSelect.length > 0) && cellsToSelect[cellsToSelect.length - 1][2];
            if( lastSelectedRow && (lastSelectedRow === (rowIndex - 1))) {
                // expand the range of contiguous cells to select, for dramatically more efficient table updates
                cellsToSelect[cellsToSelect.length - 1][2]++;
                Dyn.assert( cellsToSelect[cellsToSelect.length - 1][2] === rowIndex );
            } else {
                // add a new range of cells to select [rowStart, columnStart, rowEnd, columnEnd]
                cellsToSelect.push( [rowIndex, columnStart, rowIndex, columnEnd ] );
            }
        }
    };

    /**
     * If the table is now active and there are unhandled row selections to be made,
     * handle them now. Unhandled row selections are from setSelectedRowIDs() when
     * the table was inactive (invisible).  We are careful not to handle selections
     * if there are more recent row selection events.
     */
    handleDeferredRowSelection = () => {
        let Dyn = this.props.Dyn;
        if( this.rowSelectionDeferred && this.props.isOpen && this.props.isActive ) {
            if (this.rowSelectionByDeferredEventTimeout) {
                clearTimeout(this.rowSelectionByDeferredEventTimeout);
                //console.log("rowSelectionByDeferredEventTimeout clearTimeout");
            }
            this.rowSelectionByDeferredEventTimeout = setTimeout(() => {
                this.rowSelectionByDeferredEventTimeout = undefined;
                if (this.lastSelectBy == 'user') {
                    this.lastSelectBy = ""; // Ignore the event bubbled by afterSelection function call
                } else {
                    // select the rows, now that the table is open
                    this.lastSelectBy = 'event';
                    let [cellsToSelect, wantScrollToCell] = this.rowSelectionDeferred;
                    Dyn.debugging && console.log("handleDeferredRowSelection", cellsToSelect.length, wantScrollToCell );
                    this.hotTable?.hotInstance.selectCells( cellsToSelect, wantScrollToCell );
                }
                this.rowSelectionDeferred = null; // clear it even if ignored
            }, 300); // give time for initial render to be complete
        }
    };

    /**
     * callback after user or event based change to table selection, showing which cell(s) were
     * selected. Here we determine if a case selection or attribute selection should be triggered.
     * There will be multiple calls if a multi-cell non-contiguous range of rows and columns,
     * e.g. marquee select of cells.
     * See https://handsontable.com/docs/api/hooks/#afterselectionend
     * @param r {number} - first selected row index
     * @param c {number} - first selected column index
     * @param r2 {number} - last selected row index
     * @param c2 {number} - last selected column index
     */
    afterSelection = (r, c, r2, c2, /*preventScrolling, selectionLayerLevel */) => {
        let Dyn = this.props.Dyn;
        const viewOnly = Dyn.preferences.isViewOnly();
        if(viewOnly) {
            return;
        }
        //console.log( "CaseTableComponent.afterSelection() rows:", r, r2, ", columns:", c, c2, this.state.editingTable );
        let isSingleColumnAllCellsSelection = (c===c2 && r===0 && r2===(this.rows.length-1)),
            isSingleColumEditableNameSelected = (this.state.editingTable && c===c2 && r===0 && r2===0);
        /* NOTE: If only one row is in the table, we are not able to distinguish between clicking on a cell or
        on the column header, because the callback data is the same. */

        if( ! (isSingleColumnAllCellsSelection || isSingleColumEditableNameSelected )) {
            // select the case(s) associated with the selected cell(s)
            if (this.rowSelectionByUserTimeout) {
                // To handle bubbling events
                clearTimeout(this.rowSelectionByUserTimeout);
            }
            this.rowSelectionByUserTimeout = setTimeout(() => {
                this.rowSelectionByUserTimeout = undefined;
                if (this.lastSelectBy == 'event') {
                    // Ignore the event bubbled by setSelectedRowIds function call
                    this.lastSelectBy = "";
                } else {
                    // select the case associated with the selected cells (in table and card and plot)
                    this.lastSelectBy = 'user';
                    if (this.props.onRowSelect) {
                        const instance = this.hotTable.hotInstance;
                        let _caseIndex = instance.getData()[r][0] - 1;
                        if( _caseIndex >= 0 ){
                            this.props.onRowSelect([_caseIndex]);
                        }
                    }
                }
            }, 300);
        } else {
            // select the attribute associated with this column header
            if (this.props.onColumnSelect) {
                let columnAttrib = Dyn.dataSet.getAttributeByName(this.state.columnAttributeNames[c]);
                if (columnAttrib){
                    this.props.onColumnSelect({ // select the equivalent attribute
                        id: columnAttrib.id,
                        name: columnAttrib.name,
                    });
                }
            }
        }
    }

    handleFilterChange = (args) => {
    /*
    let newState = { // caution: notification can come before filterCheck defined
        applyFilter: Boolean( this.refs.filterCheck && this.refs.filterCheck.checked )
    };
    */
    // is filter reset applied
    if( "resetAll" in args && args.resetAll ) {
        this.setState({applyFilter: false});
    } else {
        let newState = {
            applyFilter: true
        }
        // Don't reset edit mode when applyFilter request comes
        /*
        if( newState.applyFilter ) {
            newState.editingTable = false; // turn off editing when viewing "After Filter"
        }
        */
        this.setState( newState );
    }
}


    /**
     * Get valid rows and columns
     * @returns Array
     */
    getRawData_old = () => {
        const attribs = this.props.Dyn.dataSet.attribs;
        let filteredRows = [];
        if(attribs.length > 1) {
            let maxNoOfColumns = 0;
            filteredRows = this.state.rows.map((row, index) => {
                if(index === 0) {
                    // Ignore placeholder headers
                    maxNoOfColumns = row.filter(d => d && d.match(/^<attribute[0-9]+>$/g) === null).length;
                }
                return row.slice(1, maxNoOfColumns);
            });
            // Ignore the last placeholder row
            filteredRows = filteredRows.slice(0, attribs[0].cases.length + 1);
        }
        return filteredRows;
    }

    getRawData = () => {
        // get the data table row values as "raw" values, unformatted, for saving/editing
        // see also getTableRowData() for formatted table row values when not editing.
        return this.props.Dyn.dataUtil.getTableRowDataRaw(this.props.Dyn.dataSet);
    }

    handleEditModeChange = (isEdit, disablePrepareEditMode = false) => {
        let value = isEdit;
        this.setState( state => {
            let canEdit = this.props.editable && ! state.isSampleMode,
                isEditing = Boolean( value && canEdit ),
                newState = { editingTable: isEditing };
            // Don't change applyFilter value since it doesn't take effect in edit mode
            /*
            if( isEditing ) {
                newState.applyFilter = false; // turn off "After Filter" if editing
            }
            */
            // Reset case selection while switching to edit mode
            this.props.onRowSelect && this.props.onRowSelect([]);
            return newState;
        }, () => {
            if(!isEdit) {
                // Call the callback function to trigger the save
                if(this.props.onTableDataSave) {
                    this.props.onTableDataSave(this.getRawData());
                }
            } else if(!disablePrepareEditMode) {
                // Call prepareEditMode after timeout to make sure tableview is switched to edit mode
                setTimeout(this.prepareEditMode, 100);
            }
        });
        // To post Google Analytics events
        if(isEdit) {
            _gaq.push(["_trackEvent", "Uploader Function", "Click", "Insert Data - Edit"]);
        } else {
            _gaq.push(["_trackEvent", "Uploader Function", "Click", "Insert Data - Save"]);
        }
    }

    getRows = () => {
        //console.log("CaseTableComponent.getRows()");
        let Dyn = this.props.Dyn;
        var rows = [];
        if (this.state.rows && this.state.rows.length) {
            rows = this.state.rows;
            // Apply filter in read only mode
            if (!this.state.editingTable && this.state.applyFilter) {
                let extraRowIndex = (this.state.editingTable ? (this.state.rows.length - 1) : undefined);
                rows = rows.filter((val, index) => {
                    return (!Dyn.dataSet.caseFilter.caseIsFiltered[index]) || index===extraRowIndex;
                });
            }
        }
        this.rows = rows;
        // display the number of visible case rows; must subtract any editable header row and blank rows
        this.numCaseRows = rows.length - (this.state.numEditableHeaderRows + this.state.numEditableBlankRows);
    }

    // To get localized label values
    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        if (Dyn.dataSet && str) {
            return Dyn.loc(str);
        } else {
            return str;
        }
    }

    setFocus = () => {
        this.refs.tableViewComponent.focus();
    }

    onCellChange = (changes) => {
        // handle cell edit/copy/paste in edit mode
        let Dyn = this.props.Dyn,
            firstTableRowIsAttributeName = true;
        if(changes && changes.length > 0) {
            // TODO: when afterCheck is re-enabled, bring this logic back
            // && (!this.refs.filterCheck.checked)
            Dyn.assert( this.state.editingTable && this.props.editable
                && (!this.state.isSampleMode));
            Dyn.dataSet.updateCaseTableValues( changes, firstTableRowIsAttributeName );
            if(changes.length > 1) {
                // Select first cell of next row after paste
                const lastCell = changes[changes.length-1];
                setTimeout(() => {
                    this.hotTable?.hotInstance.selectCell( lastCell[0]+1, 1 );
                });
            }
        }
    }

    getHeader() {
        let Dyn = this.props.Dyn;
        if(this.props.editable) {
            // Show inbuilt edit/save button when onTableDataSave is defined
            if(this.props.onTableDataSave) {
                if(this.state.editingTable) {
                    return <button onClick={e => {this.handleEditModeChange(false)}}><i className="tde-i tde-i-floppy-disk tde-s2"></i> { Dyn.loc("Save Data") }</button>
                } else {
                    return <button onClick={e => {this.handleEditModeChange(true)}}><i className="tde-i tde-i-pencil tde-s2"></i> { Dyn.loc("Edit Data") }</button>
                }
            } else {
                return <div></div>
            }
        } else {
            return <span><i className="tde-i tde-i-help"></i> { Dyn.loc("Read Only") }</span>
        }
    }

    dummyCellRenderer(instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.className = td.className + ' tde-dummy-cell';
    }

    // Render the UI of toolbar component
    render = () => {
        this.getRows();
        this.handleDeferredRowSelection();
        let actualNoOfColumns = this.props.Dyn.dataSet && this.props.Dyn.dataSet.getNumAttributes() || 0;
        const viewOnly = this.props.Dyn.preferences.isViewOnly();
        var _noOfCases = this.numCaseRows;
        let _height = this.props.tableViewHeight > 170? (this.props.tableViewHeight - (this.props.tableHeaderHeight || 0)) : 100;
        if(this.props.fullTableView) {
            _height = this.refs.tableViewComponent?.clientHeight;
        }
        return (
            <div ref="tableViewComponent" className={"tde-case-table-wrapper " + (this.state.editingTable? 'tde-table-editing': 'tde-table-read-only')}>
                { !viewOnly && this.props.isOpen &&
                <div className="tde-case-table-info">
                    <div className="left">
                        { this.getHeader() }
                        <span>({_noOfCases} {this.getLoc('rows')})</span>
                    </div>
                    <div className="right">
                        {this.props.wopiLink &&
                        <a className="tde-wopi-link" aria-label="Edit in Excel Online" href={this.props.wopiLink}>
                            Edit in Excel Online <i className="tde-i tde-i-excel" style={{color: '#1e6e44'}}></i>
                        </a>
                        }
                        {/* <label>
                            <input ref="editMode" name="editingTable" type="checkbox"
                                checked={this.state.editingTable}
                                onChange={this.handleEditModeChange}
                                tabIndex={this.props.isOpen ? '1' : '-1'} />
                            {this.getLoc('Edit Table')}
                        </label>
                        <label style={{visibility: this.state.editingTable? 'hidden': 'visible'}}>
                            <input ref="filterCheck" name="applyFilter" type="checkbox"
                                   checked={this.state.applyFilter}
                                   onChange={this.handleFilterChange}
                                   tabIndex={this.props.isOpen ? '1' : '-1'} />
                            {this.getLoc('After filter')}
                        </label> */}
                    </div>
                </div>
                }
                <HotTable
                    ref={(ele) => {
                        this.hotTable = ele;
                    }}
                    colHeaders={this.state.columnHTMLHeaders} // different if editing or not
                    columnHeaderHeight={ this.state.editingTable? 18 : 38 } // see also rowHeights
                    columns={this.state.columns}
                    data={this.rows.length > 0? this.rows: null}
                    height={_height}
                    rowHeaders={false}
                    rowHeights={27} // set the height for accurate auto-scroll #1287
                    // rowHeights={function(index) { return (index===0) ? 2*27 : 27; }}
                    // see https://handsontable.com/docs/6.2.2/Options.html#rowHeights
                    columnSorting={!(viewOnly || this.state.editingTable)}
                    sortIndicator={!(viewOnly || this.state.editingTable)}
                    afterSelection={this.afterSelection}
                    afterChange={this.onCellChange}
                    enterMoves={(event) => {
                        if(this.state.editingTable && !event.shiftKey) {
                            const selectedRange = this.hotTable.hotInstance.getSelected();
                            let column = null;
                            if(selectedRange.length > 0) {
                                column = this.state.columns[selectedRange[0][1]];
                            }
                            // Push new row only when column type is numeric and row number is greater than or equal 3
                            if(column?.type === 'numeric' && selectedRange[0][0] >= 3) {
                                // Push an empty row to add new row and focus the new row on enterMoves
                                this.rows.push([]);
                            }
                        }
                        return {row: 1, col: 0};
                    }}
                    cells={(row, col) => {
                        var cellProperties = {};
                        if(this.state.editingTable) {
                            if(row === 0) {
                                if(actualNoOfColumns <= col) {
                                    cellProperties.renderer = this.dummyCellRenderer;
                                }
                            } else if(_noOfCases < row) {
                                cellProperties.renderer = this.dummyCellRenderer;
                            }
                        }
                        return cellProperties;
                    }}
                    stretchH="all" />
            </div>
        )
    }
}

// To expose the component under Dyn, so that it can be access outside DataExploration Environment
// Dyn.CaseTableComponent = CaseTableComponent;
DynG.CaseTableComponent = CaseTableComponent;

export default CaseTableComponent
